import React, {Component} from 'react';
import './index.scss';
import moment from 'moment'

export default class Live extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  componentDidMount() {

  }

  //换算时间
  changeTime = (time)=>{
    const format_time = moment(time).format('HH:mm')
    // const timestamp = parseInt(new Date(time).getTime()) //转换为时间戳
    // const date = new Date(timestamp)  //转换为date
    // const hh = date.getHours()
    // const mm = date.getMinutes() > 9 ? date.getMinutes() : '0' + date.getMinutes()
    return format_time
  }

  render() {
    const {liveData} = this.props
    return <div className="live_box">
      {liveData.length > 0 ? liveData.map((item, index) => {
        return <div className="live_content"
                    key={index}>
          {item.is_top/ 1=== 1 ?
            <div className="live_top_icon"></div> : ''
          }
          <div className="live_emcee">
            <div className="emcee_header">
              <img src={item.head_image} alt={item.user_name}/>
              <div className="weibo_icon"></div>
            </div>
            {/*{index < liveData.length -1  ?*/}
              {/*<div className="live_line"></div> :''*/}
            {/*}*/}
          </div>
          <div className="live_picture">
            {/*<div className="sanjiao_icon"></div>*/}
            <div className="live_picture_head">
              <div className="emcee_name">{item.user_name}</div>
              <div className="live_time">{this.changeTime(item.add_time)}</div>
            </div>
            {item.desc ?
              <div className="live_desc">
                {item.desc.length >= 99 && !item.descType ? item.desc.substring(0, 98) : item.desc}
                {item.desc.length >= 99 && !item.descType ?
                  <span onClick={this.props.setLiveDesc.bind(this, 1,index)} className="descBtn">
              <span className="descIcon"></span>
              展开</span> :
                  item.desc.length >= 99 ?
                    <p onClick={this.props.setLiveDesc.bind(this, 2,index)} className="descBtn">收起</p> : ''
                }
              </div> : ''
            }
            {item.image_list.length > 1 ?
              item.image_list.map((imgItem,imgIndex)=>{
                return <img src={imgItem.url}
                            alt="图片"
                            className="noSingle_image"
                            key={imgIndex}/>
              }) :
              item.image_list.length === 1 ?
                <img src={item.image_list[0].url} alt="图片" className="single_image"/>
                : ''
            }
            <div className="clear"></div>
          </div>
          <div className="clear"></div>
          <div className="fengeLine"></div>
        </div>
      }) : ''}
    </div>
  }
}


// WEBPACK FOOTER //
// ./src/pages/Detail/Live/index.js